export default "__VITE_ASSET__cc4b8d54__"